import { render, staticRenderFns } from "./PopularSearch.vue?vue&type=template&id=2762d266"
import script from "./PopularSearch.vue?vue&type=script&lang=js"
export * from "./PopularSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports